import React, { FC, ReactNode, ButtonHTMLAttributes, AnchorHTMLAttributes } from 'react'
import { StyledButton, StyledButtonLink, Loader } from './Button.style'

export type themeType = {
  black: string
  grey: string
  greyDark: string
  yellow: string
  white: string
  transparent: string
  violet: string
}

export type ButtonSizeType = 'xs' | 'sm' | number

export interface ButtonType {
  children?: ReactNode
  href?: string
  size?: ButtonSizeType
  $shape?: 'circle'
  disabled?: boolean
  $loading?: boolean
  $border?: boolean
  themetype?: keyof themeType
}

const Button: FC<ButtonType & ButtonHTMLAttributes<HTMLButtonElement> & AnchorHTMLAttributes<HTMLAllCollection>> = (
  props: ButtonType
) => {
  const { children, href, ...rest } = props

  if (href) {
    return (
      <StyledButtonLink {...rest} to={href} className={'Button'}>
        {children}
      </StyledButtonLink>
    )
  }
  return (
    <StyledButton type={'button'} {...rest} className={'Button'}>
      {children}
      {props.$loading && (
        <Loader size={props.size}>
          <svg className={'loader'}>
            <use xlinkHref="#circle-loader" />
          </svg>
        </Loader>
      )}
    </StyledButton>
  )
}

export default Button
